/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BaseNonTaxableInstitutionViewModel
 */
export interface BaseNonTaxableInstitutionViewModel {
    /**
     * 
     * @type {string}
     * @memberof BaseNonTaxableInstitutionViewModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseNonTaxableInstitutionViewModel
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseNonTaxableInstitutionViewModel
     */
    popiaStatus?: string;
}

/**
 * Check if a given object implements the BaseNonTaxableInstitutionViewModel interface.
 */
export function instanceOfBaseNonTaxableInstitutionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function BaseNonTaxableInstitutionViewModelFromJSON(json: any): BaseNonTaxableInstitutionViewModel {
    return BaseNonTaxableInstitutionViewModelFromJSONTyped(json, false);
}

export function BaseNonTaxableInstitutionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseNonTaxableInstitutionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['Name'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'popiaStatus': !exists(json, 'PopiaStatus') ? undefined : json['PopiaStatus'],
    };
}

export function BaseNonTaxableInstitutionViewModelToJSON(value?: BaseNonTaxableInstitutionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Name': value.name,
        'RegistrationNumber': value.registrationNumber,
        'PopiaStatus': value.popiaStatus,
    };
}

